export class ProjectListOrderByModel {

    orderBy: ProjectListOrderByParamsModel[];





}

export class ProjectListOrderByParamsModel
{
   column: string;
   direction: string;
}
